import React from "react";
import HomeBanner from '../components/homeBanner/homeBanner';
import KtempleNav from '../components/ktempleNav/ktempleNav';
import Footer from '../components/Footer/Footer';
import VisitingTemple from '../components/VisitingTemple/VisitingTemple';
import KrishnaInnerTemplePage from "../components/krishnapage/krishnapage";
import DocumentMeta from 'react-document-meta';
import UpcomingEvents from "../components/upcomingevents/upcomingevents";

function KrishnaTemple() {
const meta = {
    title: "Krishna Temple - Radha Madhav Krishna Temple Milwaukee",
    description: "Explore the Krishna Temple at Radha Madhav Krishna Temple in Milwaukee. Experience spirituality and community.",
    keywords: "Krishna Temple, Radha Madhav Krishna Temple, Milwaukee, spirituality, community"
  };
  return (
    <div>
      <DocumentMeta {...meta} />
      <KtempleNav />
      <UpcomingEvents />
      <HomeBanner />
      <KrishnaInnerTemplePage />
      <VisitingTemple />
      <Footer />
    </div>
  )
}

export default KrishnaTemple